import { useEffect, useState } from 'react';

export function useMediaQuery(query: string): boolean {
    const [matches, setMatches] = useState(() => window.matchMedia?.(query).matches ?? false);

    useEffect(() => {
        const list = window.matchMedia(query);
        const onChange = (e: MediaQueryListEvent) => setMatches(e.matches);
        setMatches(list.matches);
        list.addEventListener('change', onChange);
        return () => list.removeEventListener('change', onChange);
    }, [query]);

    return matches;
}

/** Desktop shell (side nav) above 800px, as in the hotel console. */
export const useIsDesktop = (): boolean => useMediaQuery('(min-width: 800px)');
